import { getMessages } from '../../../../../../../store/constants';

export const CARD_SECTION_ATTACHMENTS_BUTTON_SELECT = 'card_form_attachment_button_select_drive';
export const CARD_SECTION_ATTACHMENTS_BUTTON_UPLOAD = getMessages().getText('card_form_attachment_button_upload_computer');
export const CARD_SECTION_ATTACHMENTS_BUTTON_UPLOAD_TOUCH = getMessages().getText('card_form_attachment_button_upload_device');
export const CARD_SECTION_ATTACHMENTS_NOTE_DROP = getMessages().getText('card_form_attachment_note_drop');
